import styled from "styled-components";

export const WaiterAlertWppDesignContainerFixedPosition = styled.div`
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.14), 0 0 2px 0 rgba(0, 0, 0, 0.12);
  border-radius: 12px;
  position: absolute;
  background: #FFF;
  position: fixed;
  z-index: 9999;
  bottom: 90px;
  right: 30px;
`

export const WaiterAlertWppDesignContainer = styled.div`
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  > header {
    display: flex;
    flex-direction: row;
    gap: 8px;

    justify-content: center;
    align-self: center;
    align-content: center;

    > section {
      display: flex;
      flex-direction: row;
      gap: 8px;
      justify-content: center;
      align-self: center;
      align-content: center;
      align-items: center;
    
      > span {
        color: #222;
        font-family: Poppins;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px;
        letter-spacing: 0.1px;
        width: 234px;
        height: 40px;
      }
    }

    > div {
      cursor: pointer;
    }
  }

  > footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 16px;

    > div {
      display: flex;
      flex-direction: column;

      > span {
        color: #222;
        font-family: Poppins;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        letter-spacing: 0.1px;
      }
    }

    > button {
      padding: 10px 16px;
    }
  }
`